import { useDateTimeFormat } from '@core/shared/src/hooks/useDateTimeFormat';
import { CalendarAlt, Clock, DescriptionItem, PlannedDurationIcon } from '@core/ui';
import { DateTime, Duration } from 'luxon';
import { useTranslation } from 'react-i18next';

export const UpNextWebinarDate = ({ date, duration }: { date: string; duration: string }) => {
    const { t } = useTranslation();
    const { dateFormat, broadcastDate, broadcastTime } = useDateTimeFormat(date, {
        dateFormat: 'yyyy-LL-dd',
        broadcastDate: DateTime.DATE_HUGE,
        broadcastTime: DateTime.TIME_24_SIMPLE
    });
    const plannedDuration = Duration.fromISOTime(duration);

    return (
        <dl className="webinar-item-datetime">
            <DescriptionItem icon={<CalendarAlt />} label={t('WebinarDetails.Label.Date')} hideLabel>
                <time dateTime={dateFormat}>{broadcastDate}</time>
            </DescriptionItem>
            <DescriptionItem icon={<Clock />} label={t('WebinarDetails.Label.Time')} hideLabel>
                <time dateTime={broadcastTime}>{broadcastTime}</time>
            </DescriptionItem>
            <DescriptionItem icon={<PlannedDurationIcon />} label={t('WebinarDetails.Label.Duration')} hideLabel>
                <time dateTime={plannedDuration.toFormat("h'h' m'm'")}>{plannedDuration.toFormat('h:mm')}</time>
            </DescriptionItem>
        </dl>
    );
};
